export default __webpack_public_path__ + "static/media/jacket-2.289ebe66.jpg";